import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

/**
 * Cliente da API de Descoberta de Schema do tenant.
 * Endpoints servidos por `/integracao-schema/tabelas*` no backend.
 */
export default class IntegracaoSchemaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listarTabelas(q) {
    try {
      const params = q ? { q } : {};
      return await this.api.get('/integracao-schema/tabelas', { params });
    } catch (err) { this.error.errorShow(err); throw err; }
  }

  async listarColunas(tabela) {
    try { return await this.api.get(`/integracao-schema/tabelas/${encodeURIComponent(tabela)}/colunas`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }
}
